"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _Input = _interopRequireDefault(require("../Input"));

var _validation = require("../../utils/validation");

var _uuid = require("uuid");

var _AddList = require("./AddList.style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * 可新增刪除項目列表
 */
var AddList = function AddList(_ref) {
  var _ref$data = _ref.data,
      data = _ref$data === void 0 ? [] : _ref$data,
      onChange = _ref.onChange,
      validator = _ref.validator;

  var _useState = (0, _react.useState)(""),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var _useState3 = (0, _react.useState)(""),
      _useState4 = _slicedToArray(_useState3, 2),
      message = _useState4[0],
      setMessage = _useState4[1];

  var addItemHandle = function addItemHandle() {
    var isPass = true;
    isPass = (0, _validation.required)(value);
    if (validator) isPass = (0, _validation.regex)(value, validator);

    if (!isPass) {
      setMessage("輸入的格式不正確！");
      return;
    }

    var newList = [].concat(_toConsumableArray(data), [value]);
    onChange(newList);
    setValue("");
  };

  var removeHandle = function removeHandle(reItem) {
    var newList = data.filter(function (item) {
      return item !== reItem;
    });
    onChange(newList);
  };

  var onKeyEnter = function onKeyEnter(e) {
    var isPass = true;
    isPass = (0, _validation.required)(value);
    if (validator) isPass = (0, _validation.regex)(value, validator);

    if (!isPass) {
      setMessage("輸入的格式不正確！");
      return;
    }

    var newList = [].concat(_toConsumableArray(data), [value]);
    onChange(newList);
    setValue("");
  };

  var onInputChange = function onInputChange(e) {
    var value = e.target.value;
    setValue(value);
    setMessage("");
  };

  return /*#__PURE__*/_react.default.createElement(_AddList.UiAddList, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "title"
  }, /*#__PURE__*/_react.default.createElement("span", null, "\u9805\u76EE"), /*#__PURE__*/_react.default.createElement("span", null, "\u522A\u9664")), data.map(function (item) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "item",
      key: (0, _uuid.v4)()
    }, /*#__PURE__*/_react.default.createElement("span", null, item), /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      name: "disabled_by_default",
      onClick: function onClick() {
        return removeHandle(item);
      }
    })));
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "input"
  }, /*#__PURE__*/_react.default.createElement(_Input.default, {
    onChange: onInputChange,
    value: value,
    onKeyEnter: onKeyEnter,
    message: message
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "icon"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "add",
    onClick: addItemHandle
  }))));
};

var _default = AddList;
exports.default = _default;
AddList.propTypes = {
  data: _propTypes.default.array,
  onChange: _propTypes.default.func,
  validator: _propTypes.default.any
};